<div class="modal-header" id="material-availability-modal-title">
    <h3 class="modal-title" translate="MATERIAL_AVAILABILITY_TITLE"></h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="materialAvailabilityForm">
        <fieldset [disabled]="isLoading">
            <div class="row mb-3">
                <div class="col-12 col-md-3 d-flex justify-content-md-end">
                    <label
                        class="col-form-label text-nowrap"
                        for="materialNumber"
                        translate="MATERIAL_AVAILABILITY_LABEL_MATERIALNUMBER"
                    ></label>
                </div>
                <div class="col-10 col-md-5">
                    <pace-core-text-input
                        id="materialNumber"
                        name="materialNumber"
                        [parentForm]="formChildren"
                        [(model)]="model.materialNumber"
                        [ariaLabel]="'MATERIAL_AVAILABILITY_LABEL_MATERIALNUMBER' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col-2 ms-md-auto">
                    <button
                        id="btnMaterialAdd"
                        type="button"
                        class="btn btn-primary float-end"
                        translate="MATERIAL_AVAILABILITY_LABEL_BUTTON_ADD"
                        [disabled]="isLoading || materialAvailabilityForm.invalid"
                        (click)="addMaterial()"
                    ></button>
                </div>
            </div>
            @if (displaySmartlockerCheckBoxFilter && responsePartSet.length > 0) {
                <div class="row my-3">
                    <pace-core-checkbox-input [(model)]="showSmartlockerMaterialsOnly"></pace-core-checkbox-input>
                </div>
            }
            <div class="row table-header fw-bold py-2">
                <div class="col-4 offset-1" translate="MATERIAL_AVAILABILITY_LABEL_MATERIAL"></div>
                <div class="col-3" translate="MATERIAL_AVAILABILITY_LABEL_STORAGE_LOCATION"></div>
                <div class="col" translate="MATERIAL_AVAILABILITY_LABEL_AVAILABLE"></div>
            </div>
            @if (model.partSet.value.length > 0) {
                <div class="mt-2">
                    @for (material of model.partSet.value; track material; let index = $index) {
                        <div class="row align-items-center py-2">
                            <div class="col-4 offset-1">{{ material.materialNr.value }}</div>
                            <div class="col-1 ms-auto text-end">
                                <button
                                    type="button"
                                    class="btn btn-danger"
                                    (click)="deleteMaterial(index)"
                                    [attr.aria-label]="
                                        ('MATERIAL_AVAILABILITY_DELETE_MATERIAL_ARIA_LABEL' | translate) + (index + 1)
                                    "
                                >
                                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                                </button>
                            </div>
                            @if (index < model.partSet.value.length - 1) {
                                <div class="col-12">
                                    <hr class="my-2" />
                                </div>
                            }
                        </div>
                    }
                </div>
            }
            @if (responsePartSet.length > 0) {
                <div class="row">
                    @for (material of responsePartSet; track material; let last = $last) {
                        @if (!showSmartlockerMaterialsOnly.value || isMaterialInSmartlocker(material.storageLocDesc)) {
                            <div class="table-row">
                                <pace-material-availability-details
                                    [material]="material"
                                    [responsePartSet]="responsePartSet"
                                >
                                </pace-material-availability-details>
                            </div>
                        }
                    }
                </div>
            }
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    @if (isLoading) {
        <progressbar [value]="100" type="default">Loading...</progressbar>
    }
    @if (!isLoading && sparePartsCatalogLink) {
        <div class="me-auto" paceCoreLink>
            <a
                class="btn btn-primary"
                href="{{ sparePartsCatalogLink }}"
                target="_blank"
                translate="SPARE_PARTS_CATALOG_LINK_LABEL"
            ></a>
        </div>
    }
    @if (!isLoading) {
        <button
            class="btn btn-primary ms-auto"
            type="button"
            translate="MATERIAL_AVAILABILITY_LABEL_BUTTON_CHECK"
            (click)="check()"
        ></button>
    }
</div>
